import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

const Occupation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-6">
        <div className="w-full sm:col-span-2 xl:col-span-4 text-base text-primary-blue font-semibold">
          {t("registration_form.step5.occupation_info")}
        </div>

        {/* <Form.Item
          layout={"vertical"}
          className="text-primary-blue sm:col-span-2"
          label={
            <label className="text-primary-blue">
              {t("registration_form.step5.current_occupation")}
            </label>
          }
          name="occupation"
        >
          <Select
            placeholder={t("registration_form.step5.current_occupation_hint")}
          >
            <Select.Option value="Businessman">
              {t("occupation_options.businessman")}
            </Select.Option>
            <Select.Option value="Employee">
              {t("occupation_options.employee")}
            </Select.Option>
            <Select.Option value="Official">
              {t("occupation_options.official")}
            </Select.Option>
            <Select.Option value="Others">
              {t("occupation_options.others")}
            </Select.Option>
            <Select.Option value="Retired">
              {t("occupation_options.retired")}
            </Select.Option>
            <Select.Option value="Student">
              {t("occupation_options.student")}
            </Select.Option>
            <Select.Option value="Unemployed">
              {t("occupation_options.unemployed")}
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step5.occupation_info")}
            </label>
          }
          name="occupation_info"
          style={{ color: "red" }}
        >
          <Input
            placeholder={t("registration_form.step5.occupation_info_hint")}
          />
        </Form.Item> */}

        <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step5.company_name")}
            </label>
          }
          name="company_name"
          style={{ color: "red" }}
        >
          <Input placeholder={t("registration_form.step5.company_name_hint")} />
        </Form.Item>

        {/* <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step5.position")}
            </label>
          }
          name="position_of_study"
          style={{ color: "red" }}
        >
          <Input placeholder={t("registration_form.step5.position_hint")} />
        </Form.Item> */}

        <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step5.company_address")}
            </label>
          }
          name="company_address"
          style={{ color: "red" }}
          className="xl:col-span-2"
        >
          <Input
            placeholder={t("registration_form.step5.company_address_hint")}
          />
        </Form.Item>

        <Form.Item
          layout={"vertical"}
          label={
            <label className="text-primary-blue">
              {t("registration_form.step5.company_phone_number")}
            </label>
          }
          name="company_phone_number"
          style={{ color: "red" }}
          rules={[
            {
              pattern: new RegExp(
                "^(\\+?[0-9]\\d{1,14}|(\\+84|84|0)([3|5|7|8|9])[0-9]{8})$"
              ),
              message: t("registration_form.invalid_telephone_number", {
                ns: "message",
              }),
            },
          ]}
        >
          <Input
            placeholder={t("registration_form.step5.company_phone_number_hint")}
          />
        </Form.Item>
      </div>
    </>
  );
};

export default Occupation;
